/* --------------------------------------------------------------------------------------
   print.service.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class printService {
  /*@ngInject*/
  constructor(appSettings) {
    this.appSettings = appSettings;
  }

  async SubmitPrint(blobUrl, filename, options) {
    console.log(options);
    const output = this.xrxPrintOutput(
      options.staple,
      "None",
      "None",
      options.color,
      "",
      options.copies,
      options.sides,
      "Automatic"
    );
    const input = "";
    const jobProcessing = this.xrxPrintJobProcessing(input, output);
    const jobDescription = this.xrxPrintJobDescription(
      filename,
      this.appSettings.appName
    );
    const printJobTicket = this.xrxPrintJobTicket(
      jobDescription,
      jobProcessing
    );

    const printInitiatePrintJobURLResult = await this.printInitiatePrintJobURL(
      this.appSettings.deviceUrl,
      blobUrl,
      printJobTicket
    );
    return xrxPrintParseInitiatePrintJobURL(
      printInitiatePrintJobURLResult.response
    );
  }
  printInitiatePrintJobURL(deviceUrl, blobUrl, printJobTicket) {
    return new Promise((resolve, reject) => {
      xrxPrintInitiatePrintJobURL(
        this.appSettings.deviceUrl,
        blobUrl,
        "",
        "",
        printJobTicket,
        (env, response) => resolve({ env, response }),
        (request, response, status) => reject({ request, response, status }) // TODO: handle error
      );
    });
  }
  xrxPrintOutput(
    staple,
    punch,
    fold,
    color,
    collate,
    copies,
    sides,
    inputTray
  ) {
    const finishingTag = xrxCreateTag(
      "Finishings",
      "",
      xrxCreateTag("StapleFinishing", "", staple) +
        xrxCreateTag("PunchFinishing", "", punch) +
        xrxCreateTag("FoldFinishing", "", fold)
    );
    const colorEffectsTag = xrxCreateTag("ColorEffectsType", "", color);
    const collationTag = xrxCreateTag("SheetCollate", "", collate);
    console.log("***** creating tag *****", copies);
    const copiesTag = xrxCreateTag("Copies", "", copies);
    const sidesTag = xrxCreateTag("Sides", "", sides);
    const trayTag = xrxCreateTag(
      "InputTraysCol",
      "",
      xrxCreateTag("InputTrayName", "", inputTray)
    );

    return xrxCreateTag(
      "Output",
      "",
      finishingTag +
        colorEffectsTag +
        collationTag +
        copiesTag +
        sidesTag +
        trayTag
    );
  }
  xrxPrintJobTicket(jobDescription, jobProcessing) {
    const ticketStr =
      '<?xml version="1.0" encoding="utf-8"?>' +
      xrxCreateTag(
        "PrintJobTicket",
        'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns="http://schemas.xerox.com/enterprise/eipjobmodel/1"',
        jobDescription + jobProcessing
      );
    return this.xrxEscape(ticketStr);
  }
  xrxPrintJobDescription(jobName, jobOriginating) {
    return xrxCreateTag(
      "JobDescription",
      "",
      xrxCreateTag("JobName", "", jobName) +
        xrxCreateTag("JobOriginatingUserName", "", jobOriginating)
    );
  }
  xrxPrintJobProcessing(input, output) {
    return xrxCreateTag("JobProcessing", "", input + output);
  }
  xrxEscape(text) {
    text = unescape(text);
    text = xrxReplaceChars(text, "<", "&lt;");
    text = xrxReplaceChars(text, ">", "&gt;");
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/print.service.js